// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/integration/connector/v1/catalog.proto" (package "c1.api.integration.connector.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { StringRules } from "../../../../../validate/validate";
import { Form } from "../../../form/v1/form";
import { App } from "../../../app/v1/app";
import { ConnectorRef } from "../../../app/v1/connector";
import { Any } from "../../../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorInstallation
 */
export interface ConnectorInstallation {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorInstallationView
 */
export interface ConnectorInstallationView {
    /**
     * @generated from protobuf field: c1.api.integration.connector.v1.ConnectorInstallation connector_installation = 1
     */
    connectorInstallation?: ConnectorInstallation;
    /**
     * @generated from protobuf field: string app_path = 2
     */
    appPath: string;
    /**
     * @generated from protobuf field: string connector_path = 3
     */
    connectorPath: string;
    /**
     * @generated from protobuf field: string sync_lifecycle_path = 4
     */
    syncLifecyclePath: string;
    /**
     * @generated from protobuf field: bool has_any_completed_incremental_sync = 5
     */
    hasAnyCompletedIncrementalSync: boolean;
    /**
     * For lambda-deployment-enabled connectors, the deployed connector version.
     *
     * @generated from protobuf field: string lambda_deployment_version = 6
     */
    lambdaDeploymentVersion: string;
    /**
     * For lambda-deployment-enabled connectors, the deployment channel (for example, stable/latest/preview).
     *
     * @generated from protobuf field: string lambda_deployment_channel = 7
     */
    lambdaDeploymentChannel: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorInstallationExpandMask
 */
export interface ConnectorInstallationExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalog
 */
export interface ConnectorCatalog {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @deprecated
     * @generated from protobuf field: string icon_url = 4 [deprecated = true]
     */
    iconUrl: string;
    /**
     * @deprecated
     * @generated from protobuf field: string logo_url = 5 [deprecated = true]
     */
    logoUrl: string;
    /**
     * @generated from protobuf field: bool installed = 6
     */
    installed: boolean;
    /**
     * @generated from protobuf field: string help_url = 7
     */
    helpUrl: string;
    /**
     * @generated from protobuf field: int64 connector_api_version = 8
     */
    connectorApiVersion: number;
    /**
     * @generated from protobuf field: bool retired = 9
     */
    retired: boolean;
    /**
     * @generated from protobuf field: int64 install_count = 10
     */
    installCount: number;
    /**
     * @generated from protobuf field: bool beta = 11
     */
    beta: boolean;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogView
 */
export interface ConnectorCatalogView {
    /**
     * @generated from protobuf field: c1.api.integration.connector.v1.ConnectorCatalog connector_catalog = 1
     */
    connectorCatalog?: ConnectorCatalog;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogExpandMask
 */
export interface ConnectorCatalogExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchRequest
 */
export interface ConnectorCatalogServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.integration.connector.v1.ConnectorCatalogExpandMask expand_mask = 3
     */
    expandMask?: ConnectorCatalogExpandMask;
    /**
     * @generated from protobuf field: bool retired = 5
     */
    retired: boolean;
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchResponse
 */
export interface ConnectorCatalogServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.integration.connector.v1.ConnectorCatalogView list = 1
     */
    list: ConnectorCatalogView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceGetRequest
 */
export interface ConnectorCatalogServiceGetRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceGetResponse
 */
export interface ConnectorCatalogServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.integration.connector.v1.ConnectorCatalogView catalog_view = 1
     */
    catalogView?: ConnectorCatalogView;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceListInstallationsRequest
 */
export interface ConnectorCatalogServiceListInstallationsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.integration.connector.v1.ConnectorInstallationExpandMask expand_mask = 3
     */
    expandMask?: ConnectorInstallationExpandMask;
    /**
     * @generated from protobuf field: string catalog_id = 4
     */
    catalogId: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceListInstallationsResponse
 */
export interface ConnectorCatalogServiceListInstallationsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.integration.connector.v1.ConnectorInstallationView list = 1
     */
    list: ConnectorInstallationView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchInstallationsRequest
 */
export interface ConnectorCatalogServiceSearchInstallationsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.integration.connector.v1.ConnectorInstallationExpandMask expand_mask = 3
     */
    expandMask?: ConnectorInstallationExpandMask;
    /**
     * @generated from protobuf field: repeated string application_ids = 9
     */
    applicationIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.ConnectorRef refs = 5
     */
    refs: ConnectorRef[];
    /**
     * @generated from protobuf field: string query = 6
     */
    query: string;
    /**
     * @generated from protobuf field: bool has_last_sync_id = 7
     */
    hasLastSyncId: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.ConnectorRef exclude_refs = 8
     */
    excludeRefs: ConnectorRef[];
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchInstallationsResponse
 */
export interface ConnectorCatalogServiceSearchInstallationsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.integration.connector.v1.ConnectorInstallationView list = 1
     */
    list: ConnectorInstallationView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceGetInstallationRequest
 */
export interface ConnectorCatalogServiceGetInstallationRequest {
    /**
     * @generated from protobuf field: string connector_id = 1
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: c1.api.integration.connector.v1.ConnectorInstallationExpandMask expand_mask = 3
     */
    expandMask?: ConnectorInstallationExpandMask;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceGetInstallationResponse
 */
export interface ConnectorCatalogServiceGetInstallationResponse {
    /**
     * @generated from protobuf field: c1.api.integration.connector.v1.ConnectorInstallationView connector_installation = 1
     */
    connectorInstallation?: ConnectorInstallationView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchAppsForInstallationRequest
 */
export interface ConnectorCatalogServiceSearchAppsForInstallationRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string catalog_id = 3
     */
    catalogId: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchAppsForInstallationResponse
 */
export interface ConnectorCatalogServiceSearchAppsForInstallationResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.App list = 1
     */
    list: App[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceConfigurationSchemaRequest
 */
export interface ConnectorCatalogServiceConfigurationSchemaRequest {
    /**
     * @generated from protobuf field: string catalog_id = 4
     */
    catalogId: string;
    /**
     * @generated from protobuf field: string connector_id = 5
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string app_id = 6
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceConfigurationSchemaResponse
 */
export interface ConnectorCatalogServiceConfigurationSchemaResponse {
    /**
     * @generated from protobuf field: c1.api.integration.connector.v1.ConfigSchema schema = 1
     */
    schema?: ConfigSchema;
    /**
     * @generated from protobuf field: c1.api.form.v1.Form form_schema = 2
     */
    formSchema?: Form;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConfigSchema
 */
export interface ConfigSchema {
    /**
     * @generated from protobuf field: repeated c1.api.integration.connector.v1.Field fields = 1
     */
    fields: Field[];
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: string help_url = 3
     */
    helpUrl: string;
    /**
     * @deprecated
     * @generated from protobuf field: string icon_url = 4 [deprecated = true]
     */
    iconUrl: string;
    /**
     * @generated from protobuf field: bool is_oauth2 = 5
     */
    isOauth2: boolean;
    /**
     * Optional. Metadata for displaying fields in the UI.
     *
     * @generated from protobuf field: repeated c1.api.integration.connector.v1.FieldGroup field_groups = 6
     */
    fieldGroups: FieldGroup[];
    /**
     * @generated from protobuf field: bool supports_external_resources = 7
     */
    supportsExternalResources: boolean;
    /**
     * @generated from protobuf field: bool requires_external_connector = 8
     */
    requiresExternalConnector: boolean;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.FieldGroup
 */
export interface FieldGroup {
    /**
     * Unique ID.
     *
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * Nice name this group (e.g. renders as a Tab label)
     *
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * Optional. User-facing help text.
     *
     * @generated from protobuf field: string help_text = 3
     */
    helpText: string;
    /**
     * Field names are "guaranteed" to be unique, but can be repeated in and between lists.
     *
     * @generated from protobuf field: repeated string field_names = 4
     */
    fieldNames: string[];
    /**
     * @generated from protobuf field: bool default = 5
     */
    default: boolean;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.Field
 */
export interface Field {
    /**
     * Must not start with `C1_` and match [a-zA-Z0-9_]{2,64}.  Must be unique within a connector.
     *
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * empty or https URL
     *
     * @generated from protobuf field: string help_url = 2
     */
    helpUrl: string;
    /**
     * Human-readable label for this Field
     *
     * @generated from protobuf field: string display_name = 3
     */
    displayName: string;
    /**
     * @generated from protobuf field: string placeholder = 4
     */
    placeholder: string;
    /**
     * Optional. Additional placeholder text for the field
     * In cases where a single placeholder is not enough to describe the field
     *
     * @generated from protobuf field: string additional_placeholder = 7
     */
    additionalPlaceholder: string;
    /**
     * @generated from protobuf field: bool post_create = 5
     */
    postCreate: boolean;
    /**
     * @generated from protobuf oneof: field
     */
    field: {
        oneofKind: "str";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.StringField str = 100
         */
        str: StringField;
    } | {
        oneofKind: "select";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.SelectField select = 101
         */
        select: SelectField;
    } | {
        oneofKind: "random";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.RandomStringField random = 102
         */
        random: RandomStringField;
    } | {
        oneofKind: "import";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.ImportField import = 103
         */
        import: ImportField;
    } | {
        oneofKind: "oauth2";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.OAuth2Field oauth2 = 104
         */
        oauth2: OAuth2Field;
    } | {
        oneofKind: "readOnly";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.ReadOnlyField read_only = 105
         */
        readOnly: ReadOnlyField;
    } | {
        oneofKind: "options";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.OptionsField options = 106
         */
        options: OptionsField;
    } | {
        oneofKind: "checkbox";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.CheckboxField checkbox = 107
         */
        checkbox: CheckboxField;
    } | {
        oneofKind: "secret";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.RotatableSecretField secret = 108
         */
        secret: RotatableSecretField;
    } | {
        oneofKind: "strList";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.StringListField str_list = 109
         */
        strList: StringListField;
    } | {
        oneofKind: "text";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.TextField text = 110
         */
        text: TextField;
    } | {
        oneofKind: "keyValue";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.KeyValueField key_value = 111
         */
        keyValue: KeyValueField;
    } | {
        oneofKind: "stringMap";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.StringMapField string_map = 112
         */
        stringMap: StringMapField;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: repeated string depends_on_fields = 6
     */
    dependsOnFields: string[];
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.StringField
 */
export interface StringField {
    /**
     * If secret, value is write-only in UI and a password-type form is used.
     *
     * @generated from protobuf field: bool secret = 1
     */
    secret: boolean;
    /**
     * validator rules for value. may be empty.
     *
     * @generated from protobuf field: validate.StringRules value_validator = 2
     */
    valueValidator?: StringRules;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.StringListField
 */
export interface StringListField {
    /**
     * validator rules for value. may be empty.
     *
     * @generated from protobuf field: validate.StringRules value_validator = 1
     */
    valueValidator?: StringRules;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.KeyValueField
 */
export interface KeyValueField {
    /**
     * @generated from protobuf field: bool secret = 1
     */
    secret: boolean;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.StringMapField
 */
export interface StringMapField {
    /**
     * @generated from protobuf field: bool optional = 1
     */
    optional: boolean;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ReadOnlyField
 */
export interface ReadOnlyField {
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.SelectField
 */
export interface SelectField {
    /**
     * list of items that are selected from
     *
     * @generated from protobuf field: repeated c1.api.integration.connector.v1.SelectField.Item items = 5
     */
    items: SelectField_Item[];
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.SelectField.Item
 */
export interface SelectField_Item {
    /**
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * @generated from protobuf field: string value = 2
     */
    value: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.RandomStringField
 */
export interface RandomStringField {
    /**
     * @generated from protobuf field: int32 length = 1
     */
    length: number;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ImportField
 */
export interface ImportField {
    /**
     * @generated from protobuf field: bool secret = 1
     */
    secret: boolean;
    /**
     * @generated from protobuf field: validate.StringRules value_validator = 2
     */
    valueValidator?: StringRules;
    /**
     * @generated from protobuf field: repeated string allowed_extensions = 3
     */
    allowedExtensions: string[];
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.OAuth2Field
 */
export interface OAuth2Field {
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.OptionsField
 */
export interface OptionsField {
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.CheckboxField
 */
export interface CheckboxField {
    /**
     * @generated from protobuf field: bool checked = 1
     */
    checked: boolean;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.RotatableSecretField
 */
export interface RotatableSecretField {
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.TextField
 */
export interface TextField {
    /**
     * validator rules for value. may be empty.
     *
     * @generated from protobuf field: validate.StringRules value_validator = 1
     */
    valueValidator?: StringRules;
    /**
     * @generated from protobuf field: bool secret = 2
     */
    secret: boolean;
}
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorInstallation$Type extends MessageType<ConnectorInstallation> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorInstallation", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorInstallation>): ConnectorInstallation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorInstallation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorInstallation): ConnectorInstallation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorInstallation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorInstallation
 */
export const ConnectorInstallation = new ConnectorInstallation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorInstallationView$Type extends MessageType<ConnectorInstallationView> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorInstallationView", [
            { no: 1, name: "connector_installation", kind: "message", T: () => ConnectorInstallation },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connector_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sync_lifecycle_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "has_any_completed_incremental_sync", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "lambda_deployment_version", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "lambda_deployment_channel", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorInstallationView>): ConnectorInstallationView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appPath = "";
        message.connectorPath = "";
        message.syncLifecyclePath = "";
        message.hasAnyCompletedIncrementalSync = false;
        message.lambdaDeploymentVersion = "";
        message.lambdaDeploymentChannel = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorInstallationView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorInstallationView): ConnectorInstallationView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.integration.connector.v1.ConnectorInstallation connector_installation */ 1:
                    message.connectorInstallation = ConnectorInstallation.internalBinaryRead(reader, reader.uint32(), options, message.connectorInstallation);
                    break;
                case /* string app_path */ 2:
                    message.appPath = reader.string();
                    break;
                case /* string connector_path */ 3:
                    message.connectorPath = reader.string();
                    break;
                case /* string sync_lifecycle_path */ 4:
                    message.syncLifecyclePath = reader.string();
                    break;
                case /* bool has_any_completed_incremental_sync */ 5:
                    message.hasAnyCompletedIncrementalSync = reader.bool();
                    break;
                case /* string lambda_deployment_version */ 6:
                    message.lambdaDeploymentVersion = reader.string();
                    break;
                case /* string lambda_deployment_channel */ 7:
                    message.lambdaDeploymentChannel = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorInstallationView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.integration.connector.v1.ConnectorInstallation connector_installation = 1; */
        if (message.connectorInstallation)
            ConnectorInstallation.internalBinaryWrite(message.connectorInstallation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_path = 2; */
        if (message.appPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appPath);
        /* string connector_path = 3; */
        if (message.connectorPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.connectorPath);
        /* string sync_lifecycle_path = 4; */
        if (message.syncLifecyclePath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.syncLifecyclePath);
        /* bool has_any_completed_incremental_sync = 5; */
        if (message.hasAnyCompletedIncrementalSync !== false)
            writer.tag(5, WireType.Varint).bool(message.hasAnyCompletedIncrementalSync);
        /* string lambda_deployment_version = 6; */
        if (message.lambdaDeploymentVersion !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.lambdaDeploymentVersion);
        /* string lambda_deployment_channel = 7; */
        if (message.lambdaDeploymentChannel !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.lambdaDeploymentChannel);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorInstallationView
 */
export const ConnectorInstallationView = new ConnectorInstallationView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorInstallationExpandMask$Type extends MessageType<ConnectorInstallationExpandMask> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorInstallationExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "connector_id", "sync_lifecycle_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorInstallationExpandMask>): ConnectorInstallationExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<ConnectorInstallationExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorInstallationExpandMask): ConnectorInstallationExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorInstallationExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorInstallationExpandMask
 */
export const ConnectorInstallationExpandMask = new ConnectorInstallationExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalog$Type extends MessageType<ConnectorCatalog> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalog", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "icon_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "logo_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "installed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "help_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "connector_api_version", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 9, name: "retired", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "install_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 11, name: "beta", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorCatalog>): ConnectorCatalog {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.description = "";
        message.iconUrl = "";
        message.logoUrl = "";
        message.installed = false;
        message.helpUrl = "";
        message.connectorApiVersion = 0;
        message.retired = false;
        message.installCount = 0;
        message.beta = false;
        if (value !== undefined)
            reflectionMergePartial<ConnectorCatalog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorCatalog): ConnectorCatalog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string icon_url = 4 [deprecated = true] */ 4:
                    message.iconUrl = reader.string();
                    break;
                case /* string logo_url = 5 [deprecated = true] */ 5:
                    message.logoUrl = reader.string();
                    break;
                case /* bool installed */ 6:
                    message.installed = reader.bool();
                    break;
                case /* string help_url */ 7:
                    message.helpUrl = reader.string();
                    break;
                case /* int64 connector_api_version */ 8:
                    message.connectorApiVersion = reader.int64().toNumber();
                    break;
                case /* bool retired */ 9:
                    message.retired = reader.bool();
                    break;
                case /* int64 install_count */ 10:
                    message.installCount = reader.int64().toNumber();
                    break;
                case /* bool beta */ 11:
                    message.beta = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorCatalog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string icon_url = 4 [deprecated = true]; */
        if (message.iconUrl !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.iconUrl);
        /* string logo_url = 5 [deprecated = true]; */
        if (message.logoUrl !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.logoUrl);
        /* bool installed = 6; */
        if (message.installed !== false)
            writer.tag(6, WireType.Varint).bool(message.installed);
        /* string help_url = 7; */
        if (message.helpUrl !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.helpUrl);
        /* int64 connector_api_version = 8; */
        if (message.connectorApiVersion !== 0)
            writer.tag(8, WireType.Varint).int64(message.connectorApiVersion);
        /* bool retired = 9; */
        if (message.retired !== false)
            writer.tag(9, WireType.Varint).bool(message.retired);
        /* int64 install_count = 10; */
        if (message.installCount !== 0)
            writer.tag(10, WireType.Varint).int64(message.installCount);
        /* bool beta = 11; */
        if (message.beta !== false)
            writer.tag(11, WireType.Varint).bool(message.beta);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalog
 */
export const ConnectorCatalog = new ConnectorCatalog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogView$Type extends MessageType<ConnectorCatalogView> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogView", [
            { no: 1, name: "connector_catalog", kind: "message", T: () => ConnectorCatalog }
        ]);
    }
    create(value?: PartialMessage<ConnectorCatalogView>): ConnectorCatalogView {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorCatalogView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorCatalogView): ConnectorCatalogView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.integration.connector.v1.ConnectorCatalog connector_catalog */ 1:
                    message.connectorCatalog = ConnectorCatalog.internalBinaryRead(reader, reader.uint32(), options, message.connectorCatalog);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorCatalogView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.integration.connector.v1.ConnectorCatalog connector_catalog = 1; */
        if (message.connectorCatalog)
            ConnectorCatalog.internalBinaryWrite(message.connectorCatalog, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogView
 */
export const ConnectorCatalogView = new ConnectorCatalogView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogExpandMask$Type extends MessageType<ConnectorCatalogExpandMask> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorCatalogExpandMask>): ConnectorCatalogExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<ConnectorCatalogExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorCatalogExpandMask): ConnectorCatalogExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorCatalogExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogExpandMask
 */
export const ConnectorCatalogExpandMask = new ConnectorCatalogExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceSearchRequest$Type extends MessageType<ConnectorCatalogServiceSearchRequest> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => ConnectorCatalogExpandMask },
            { no: 5, name: "retired", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorCatalogServiceSearchRequest>): ConnectorCatalogServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.retired = false;
        message.query = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorCatalogServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorCatalogServiceSearchRequest): ConnectorCatalogServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.integration.connector.v1.ConnectorCatalogExpandMask expand_mask */ 3:
                    message.expandMask = ConnectorCatalogExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* bool retired */ 5:
                    message.retired = reader.bool();
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorCatalogServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.integration.connector.v1.ConnectorCatalogExpandMask expand_mask = 3; */
        if (message.expandMask)
            ConnectorCatalogExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        /* bool retired = 5; */
        if (message.retired !== false)
            writer.tag(5, WireType.Varint).bool(message.retired);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchRequest
 */
export const ConnectorCatalogServiceSearchRequest = new ConnectorCatalogServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceSearchResponse$Type extends MessageType<ConnectorCatalogServiceSearchResponse> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorCatalogView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorCatalogServiceSearchResponse>): ConnectorCatalogServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorCatalogServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorCatalogServiceSearchResponse): ConnectorCatalogServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.integration.connector.v1.ConnectorCatalogView list */ 1:
                    message.list.push(ConnectorCatalogView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorCatalogServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.integration.connector.v1.ConnectorCatalogView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ConnectorCatalogView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchResponse
 */
export const ConnectorCatalogServiceSearchResponse = new ConnectorCatalogServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceGetRequest$Type extends MessageType<ConnectorCatalogServiceGetRequest> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceGetRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorCatalogServiceGetRequest>): ConnectorCatalogServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorCatalogServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorCatalogServiceGetRequest): ConnectorCatalogServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorCatalogServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceGetRequest
 */
export const ConnectorCatalogServiceGetRequest = new ConnectorCatalogServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceGetResponse$Type extends MessageType<ConnectorCatalogServiceGetResponse> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceGetResponse", [
            { no: 1, name: "catalog_view", kind: "message", T: () => ConnectorCatalogView }
        ]);
    }
    create(value?: PartialMessage<ConnectorCatalogServiceGetResponse>): ConnectorCatalogServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorCatalogServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorCatalogServiceGetResponse): ConnectorCatalogServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.integration.connector.v1.ConnectorCatalogView catalog_view */ 1:
                    message.catalogView = ConnectorCatalogView.internalBinaryRead(reader, reader.uint32(), options, message.catalogView);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorCatalogServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.integration.connector.v1.ConnectorCatalogView catalog_view = 1; */
        if (message.catalogView)
            ConnectorCatalogView.internalBinaryWrite(message.catalogView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceGetResponse
 */
export const ConnectorCatalogServiceGetResponse = new ConnectorCatalogServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceListInstallationsRequest$Type extends MessageType<ConnectorCatalogServiceListInstallationsRequest> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceListInstallationsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => ConnectorInstallationExpandMask },
            { no: 4, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorCatalogServiceListInstallationsRequest>): ConnectorCatalogServiceListInstallationsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.catalogId = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorCatalogServiceListInstallationsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorCatalogServiceListInstallationsRequest): ConnectorCatalogServiceListInstallationsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.integration.connector.v1.ConnectorInstallationExpandMask expand_mask */ 3:
                    message.expandMask = ConnectorInstallationExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* string catalog_id */ 4:
                    message.catalogId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorCatalogServiceListInstallationsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.integration.connector.v1.ConnectorInstallationExpandMask expand_mask = 3; */
        if (message.expandMask)
            ConnectorInstallationExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string catalog_id = 4; */
        if (message.catalogId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.catalogId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceListInstallationsRequest
 */
export const ConnectorCatalogServiceListInstallationsRequest = new ConnectorCatalogServiceListInstallationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceListInstallationsResponse$Type extends MessageType<ConnectorCatalogServiceListInstallationsResponse> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceListInstallationsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorInstallationView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorCatalogServiceListInstallationsResponse>): ConnectorCatalogServiceListInstallationsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorCatalogServiceListInstallationsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorCatalogServiceListInstallationsResponse): ConnectorCatalogServiceListInstallationsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.integration.connector.v1.ConnectorInstallationView list */ 1:
                    message.list.push(ConnectorInstallationView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorCatalogServiceListInstallationsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.integration.connector.v1.ConnectorInstallationView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ConnectorInstallationView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceListInstallationsResponse
 */
export const ConnectorCatalogServiceListInstallationsResponse = new ConnectorCatalogServiceListInstallationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceSearchInstallationsRequest$Type extends MessageType<ConnectorCatalogServiceSearchInstallationsRequest> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceSearchInstallationsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => ConnectorInstallationExpandMask },
            { no: 9, name: "application_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "128", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorRef },
            { no: 6, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 7, name: "has_last_sync_id", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "exclude_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorRef }
        ]);
    }
    create(value?: PartialMessage<ConnectorCatalogServiceSearchInstallationsRequest>): ConnectorCatalogServiceSearchInstallationsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.applicationIds = [];
        message.refs = [];
        message.query = "";
        message.hasLastSyncId = false;
        message.excludeRefs = [];
        if (value !== undefined)
            reflectionMergePartial<ConnectorCatalogServiceSearchInstallationsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorCatalogServiceSearchInstallationsRequest): ConnectorCatalogServiceSearchInstallationsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.integration.connector.v1.ConnectorInstallationExpandMask expand_mask */ 3:
                    message.expandMask = ConnectorInstallationExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated string application_ids */ 9:
                    message.applicationIds.push(reader.string());
                    break;
                case /* repeated c1.api.app.v1.ConnectorRef refs */ 5:
                    message.refs.push(ConnectorRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string query */ 6:
                    message.query = reader.string();
                    break;
                case /* bool has_last_sync_id */ 7:
                    message.hasLastSyncId = reader.bool();
                    break;
                case /* repeated c1.api.app.v1.ConnectorRef exclude_refs */ 8:
                    message.excludeRefs.push(ConnectorRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorCatalogServiceSearchInstallationsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.integration.connector.v1.ConnectorInstallationExpandMask expand_mask = 3; */
        if (message.expandMask)
            ConnectorInstallationExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.ConnectorRef refs = 5; */
        for (let i = 0; i < message.refs.length; i++)
            ConnectorRef.internalBinaryWrite(message.refs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string query = 6; */
        if (message.query !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.query);
        /* bool has_last_sync_id = 7; */
        if (message.hasLastSyncId !== false)
            writer.tag(7, WireType.Varint).bool(message.hasLastSyncId);
        /* repeated c1.api.app.v1.ConnectorRef exclude_refs = 8; */
        for (let i = 0; i < message.excludeRefs.length; i++)
            ConnectorRef.internalBinaryWrite(message.excludeRefs[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated string application_ids = 9; */
        for (let i = 0; i < message.applicationIds.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.applicationIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchInstallationsRequest
 */
export const ConnectorCatalogServiceSearchInstallationsRequest = new ConnectorCatalogServiceSearchInstallationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceSearchInstallationsResponse$Type extends MessageType<ConnectorCatalogServiceSearchInstallationsResponse> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceSearchInstallationsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorInstallationView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorCatalogServiceSearchInstallationsResponse>): ConnectorCatalogServiceSearchInstallationsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorCatalogServiceSearchInstallationsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorCatalogServiceSearchInstallationsResponse): ConnectorCatalogServiceSearchInstallationsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.integration.connector.v1.ConnectorInstallationView list */ 1:
                    message.list.push(ConnectorInstallationView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorCatalogServiceSearchInstallationsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.integration.connector.v1.ConnectorInstallationView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ConnectorInstallationView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchInstallationsResponse
 */
export const ConnectorCatalogServiceSearchInstallationsResponse = new ConnectorCatalogServiceSearchInstallationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceGetInstallationRequest$Type extends MessageType<ConnectorCatalogServiceGetInstallationRequest> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceGetInstallationRequest", [
            { no: 1, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => ConnectorInstallationExpandMask }
        ]);
    }
    create(value?: PartialMessage<ConnectorCatalogServiceGetInstallationRequest>): ConnectorCatalogServiceGetInstallationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.connectorId = "";
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorCatalogServiceGetInstallationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorCatalogServiceGetInstallationRequest): ConnectorCatalogServiceGetInstallationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string connector_id */ 1:
                    message.connectorId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* c1.api.integration.connector.v1.ConnectorInstallationExpandMask expand_mask */ 3:
                    message.expandMask = ConnectorInstallationExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorCatalogServiceGetInstallationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string connector_id = 1; */
        if (message.connectorId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.connectorId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* c1.api.integration.connector.v1.ConnectorInstallationExpandMask expand_mask = 3; */
        if (message.expandMask)
            ConnectorInstallationExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceGetInstallationRequest
 */
export const ConnectorCatalogServiceGetInstallationRequest = new ConnectorCatalogServiceGetInstallationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceGetInstallationResponse$Type extends MessageType<ConnectorCatalogServiceGetInstallationResponse> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceGetInstallationResponse", [
            { no: 1, name: "connector_installation", kind: "message", T: () => ConnectorInstallationView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<ConnectorCatalogServiceGetInstallationResponse>): ConnectorCatalogServiceGetInstallationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<ConnectorCatalogServiceGetInstallationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorCatalogServiceGetInstallationResponse): ConnectorCatalogServiceGetInstallationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.integration.connector.v1.ConnectorInstallationView connector_installation */ 1:
                    message.connectorInstallation = ConnectorInstallationView.internalBinaryRead(reader, reader.uint32(), options, message.connectorInstallation);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorCatalogServiceGetInstallationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.integration.connector.v1.ConnectorInstallationView connector_installation = 1; */
        if (message.connectorInstallation)
            ConnectorInstallationView.internalBinaryWrite(message.connectorInstallation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceGetInstallationResponse
 */
export const ConnectorCatalogServiceGetInstallationResponse = new ConnectorCatalogServiceGetInstallationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceSearchAppsForInstallationRequest$Type extends MessageType<ConnectorCatalogServiceSearchAppsForInstallationRequest> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceSearchAppsForInstallationRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ConnectorCatalogServiceSearchAppsForInstallationRequest>): ConnectorCatalogServiceSearchAppsForInstallationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.catalogId = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorCatalogServiceSearchAppsForInstallationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorCatalogServiceSearchAppsForInstallationRequest): ConnectorCatalogServiceSearchAppsForInstallationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string catalog_id */ 3:
                    message.catalogId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorCatalogServiceSearchAppsForInstallationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string catalog_id = 3; */
        if (message.catalogId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.catalogId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchAppsForInstallationRequest
 */
export const ConnectorCatalogServiceSearchAppsForInstallationRequest = new ConnectorCatalogServiceSearchAppsForInstallationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceSearchAppsForInstallationResponse$Type extends MessageType<ConnectorCatalogServiceSearchAppsForInstallationResponse> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceSearchAppsForInstallationResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => App },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorCatalogServiceSearchAppsForInstallationResponse>): ConnectorCatalogServiceSearchAppsForInstallationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorCatalogServiceSearchAppsForInstallationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorCatalogServiceSearchAppsForInstallationResponse): ConnectorCatalogServiceSearchAppsForInstallationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.App list */ 1:
                    message.list.push(App.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorCatalogServiceSearchAppsForInstallationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.App list = 1; */
        for (let i = 0; i < message.list.length; i++)
            App.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchAppsForInstallationResponse
 */
export const ConnectorCatalogServiceSearchAppsForInstallationResponse = new ConnectorCatalogServiceSearchAppsForInstallationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceConfigurationSchemaRequest$Type extends MessageType<ConnectorCatalogServiceConfigurationSchemaRequest> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceConfigurationSchemaRequest", [
            { no: 4, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConnectorCatalogServiceConfigurationSchemaRequest>): ConnectorCatalogServiceConfigurationSchemaRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.connectorId = "";
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<ConnectorCatalogServiceConfigurationSchemaRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorCatalogServiceConfigurationSchemaRequest): ConnectorCatalogServiceConfigurationSchemaRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 4:
                    message.catalogId = reader.string();
                    break;
                case /* string connector_id */ 5:
                    message.connectorId = reader.string();
                    break;
                case /* string app_id */ 6:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorCatalogServiceConfigurationSchemaRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 4; */
        if (message.catalogId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.catalogId);
        /* string connector_id = 5; */
        if (message.connectorId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.connectorId);
        /* string app_id = 6; */
        if (message.appId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceConfigurationSchemaRequest
 */
export const ConnectorCatalogServiceConfigurationSchemaRequest = new ConnectorCatalogServiceConfigurationSchemaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceConfigurationSchemaResponse$Type extends MessageType<ConnectorCatalogServiceConfigurationSchemaResponse> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceConfigurationSchemaResponse", [
            { no: 1, name: "schema", kind: "message", T: () => ConfigSchema },
            { no: 2, name: "form_schema", kind: "message", T: () => Form }
        ]);
    }
    create(value?: PartialMessage<ConnectorCatalogServiceConfigurationSchemaResponse>): ConnectorCatalogServiceConfigurationSchemaResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConnectorCatalogServiceConfigurationSchemaResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConnectorCatalogServiceConfigurationSchemaResponse): ConnectorCatalogServiceConfigurationSchemaResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.integration.connector.v1.ConfigSchema schema */ 1:
                    message.schema = ConfigSchema.internalBinaryRead(reader, reader.uint32(), options, message.schema);
                    break;
                case /* c1.api.form.v1.Form form_schema */ 2:
                    message.formSchema = Form.internalBinaryRead(reader, reader.uint32(), options, message.formSchema);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConnectorCatalogServiceConfigurationSchemaResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.integration.connector.v1.ConfigSchema schema = 1; */
        if (message.schema)
            ConfigSchema.internalBinaryWrite(message.schema, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.form.v1.Form form_schema = 2; */
        if (message.formSchema)
            Form.internalBinaryWrite(message.formSchema, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceConfigurationSchemaResponse
 */
export const ConnectorCatalogServiceConfigurationSchemaResponse = new ConnectorCatalogServiceConfigurationSchemaResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigSchema$Type extends MessageType<ConfigSchema> {
    constructor() {
        super("c1.api.integration.connector.v1.ConfigSchema", [
            { no: 1, name: "fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Field },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "help_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "icon_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "is_oauth2", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "field_groups", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FieldGroup },
            { no: 7, name: "supports_external_resources", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "requires_external_connector", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ConfigSchema>): ConfigSchema {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fields = [];
        message.displayName = "";
        message.helpUrl = "";
        message.iconUrl = "";
        message.isOauth2 = false;
        message.fieldGroups = [];
        message.supportsExternalResources = false;
        message.requiresExternalConnector = false;
        if (value !== undefined)
            reflectionMergePartial<ConfigSchema>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConfigSchema): ConfigSchema {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.integration.connector.v1.Field fields */ 1:
                    message.fields.push(Field.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string help_url */ 3:
                    message.helpUrl = reader.string();
                    break;
                case /* string icon_url = 4 [deprecated = true] */ 4:
                    message.iconUrl = reader.string();
                    break;
                case /* bool is_oauth2 */ 5:
                    message.isOauth2 = reader.bool();
                    break;
                case /* repeated c1.api.integration.connector.v1.FieldGroup field_groups */ 6:
                    message.fieldGroups.push(FieldGroup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool supports_external_resources */ 7:
                    message.supportsExternalResources = reader.bool();
                    break;
                case /* bool requires_external_connector */ 8:
                    message.requiresExternalConnector = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConfigSchema, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.integration.connector.v1.Field fields = 1; */
        for (let i = 0; i < message.fields.length; i++)
            Field.internalBinaryWrite(message.fields[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string help_url = 3; */
        if (message.helpUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.helpUrl);
        /* string icon_url = 4 [deprecated = true]; */
        if (message.iconUrl !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.iconUrl);
        /* bool is_oauth2 = 5; */
        if (message.isOauth2 !== false)
            writer.tag(5, WireType.Varint).bool(message.isOauth2);
        /* repeated c1.api.integration.connector.v1.FieldGroup field_groups = 6; */
        for (let i = 0; i < message.fieldGroups.length; i++)
            FieldGroup.internalBinaryWrite(message.fieldGroups[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bool supports_external_resources = 7; */
        if (message.supportsExternalResources !== false)
            writer.tag(7, WireType.Varint).bool(message.supportsExternalResources);
        /* bool requires_external_connector = 8; */
        if (message.requiresExternalConnector !== false)
            writer.tag(8, WireType.Varint).bool(message.requiresExternalConnector);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConfigSchema
 */
export const ConfigSchema = new ConfigSchema$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FieldGroup$Type extends MessageType<FieldGroup> {
    constructor() {
        super("c1.api.integration.connector.v1.FieldGroup", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "help_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "field_names", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<FieldGroup>): FieldGroup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.displayName = "";
        message.helpText = "";
        message.fieldNames = [];
        message.default = false;
        if (value !== undefined)
            reflectionMergePartial<FieldGroup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FieldGroup): FieldGroup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string help_text */ 3:
                    message.helpText = reader.string();
                    break;
                case /* repeated string field_names */ 4:
                    message.fieldNames.push(reader.string());
                    break;
                case /* bool default */ 5:
                    message.default = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FieldGroup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string help_text = 3; */
        if (message.helpText !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.helpText);
        /* repeated string field_names = 4; */
        for (let i = 0; i < message.fieldNames.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.fieldNames[i]);
        /* bool default = 5; */
        if (message.default !== false)
            writer.tag(5, WireType.Varint).bool(message.default);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.FieldGroup
 */
export const FieldGroup = new FieldGroup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Field$Type extends MessageType<Field> {
    constructor() {
        super("c1.api.integration.connector.v1.Field", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "help_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "placeholder", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "additional_placeholder", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "post_create", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 100, name: "str", kind: "message", oneof: "field", T: () => StringField },
            { no: 101, name: "select", kind: "message", oneof: "field", T: () => SelectField },
            { no: 102, name: "random", kind: "message", oneof: "field", T: () => RandomStringField },
            { no: 103, name: "import", kind: "message", oneof: "field", T: () => ImportField },
            { no: 104, name: "oauth2", kind: "message", oneof: "field", T: () => OAuth2Field },
            { no: 105, name: "read_only", kind: "message", oneof: "field", T: () => ReadOnlyField },
            { no: 106, name: "options", kind: "message", oneof: "field", T: () => OptionsField },
            { no: 107, name: "checkbox", kind: "message", oneof: "field", T: () => CheckboxField },
            { no: 108, name: "secret", kind: "message", oneof: "field", T: () => RotatableSecretField },
            { no: 109, name: "str_list", kind: "message", oneof: "field", T: () => StringListField },
            { no: 110, name: "text", kind: "message", oneof: "field", T: () => TextField },
            { no: 111, name: "key_value", kind: "message", oneof: "field", T: () => KeyValueField },
            { no: 112, name: "string_map", kind: "message", oneof: "field", T: () => StringMapField },
            { no: 6, name: "depends_on_fields", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Field>): Field {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.helpUrl = "";
        message.displayName = "";
        message.placeholder = "";
        message.additionalPlaceholder = "";
        message.postCreate = false;
        message.field = { oneofKind: undefined };
        message.dependsOnFields = [];
        if (value !== undefined)
            reflectionMergePartial<Field>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Field): Field {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string help_url */ 2:
                    message.helpUrl = reader.string();
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                case /* string placeholder */ 4:
                    message.placeholder = reader.string();
                    break;
                case /* string additional_placeholder */ 7:
                    message.additionalPlaceholder = reader.string();
                    break;
                case /* bool post_create */ 5:
                    message.postCreate = reader.bool();
                    break;
                case /* c1.api.integration.connector.v1.StringField str */ 100:
                    message.field = {
                        oneofKind: "str",
                        str: StringField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).str)
                    };
                    break;
                case /* c1.api.integration.connector.v1.SelectField select */ 101:
                    message.field = {
                        oneofKind: "select",
                        select: SelectField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).select)
                    };
                    break;
                case /* c1.api.integration.connector.v1.RandomStringField random */ 102:
                    message.field = {
                        oneofKind: "random",
                        random: RandomStringField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).random)
                    };
                    break;
                case /* c1.api.integration.connector.v1.ImportField import */ 103:
                    message.field = {
                        oneofKind: "import",
                        import: ImportField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).import)
                    };
                    break;
                case /* c1.api.integration.connector.v1.OAuth2Field oauth2 */ 104:
                    message.field = {
                        oneofKind: "oauth2",
                        oauth2: OAuth2Field.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).oauth2)
                    };
                    break;
                case /* c1.api.integration.connector.v1.ReadOnlyField read_only */ 105:
                    message.field = {
                        oneofKind: "readOnly",
                        readOnly: ReadOnlyField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).readOnly)
                    };
                    break;
                case /* c1.api.integration.connector.v1.OptionsField options */ 106:
                    message.field = {
                        oneofKind: "options",
                        options: OptionsField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).options)
                    };
                    break;
                case /* c1.api.integration.connector.v1.CheckboxField checkbox */ 107:
                    message.field = {
                        oneofKind: "checkbox",
                        checkbox: CheckboxField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).checkbox)
                    };
                    break;
                case /* c1.api.integration.connector.v1.RotatableSecretField secret */ 108:
                    message.field = {
                        oneofKind: "secret",
                        secret: RotatableSecretField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).secret)
                    };
                    break;
                case /* c1.api.integration.connector.v1.StringListField str_list */ 109:
                    message.field = {
                        oneofKind: "strList",
                        strList: StringListField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).strList)
                    };
                    break;
                case /* c1.api.integration.connector.v1.TextField text */ 110:
                    message.field = {
                        oneofKind: "text",
                        text: TextField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).text)
                    };
                    break;
                case /* c1.api.integration.connector.v1.KeyValueField key_value */ 111:
                    message.field = {
                        oneofKind: "keyValue",
                        keyValue: KeyValueField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).keyValue)
                    };
                    break;
                case /* c1.api.integration.connector.v1.StringMapField string_map */ 112:
                    message.field = {
                        oneofKind: "stringMap",
                        stringMap: StringMapField.internalBinaryRead(reader, reader.uint32(), options, (message.field as any).stringMap)
                    };
                    break;
                case /* repeated string depends_on_fields */ 6:
                    message.dependsOnFields.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Field, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string help_url = 2; */
        if (message.helpUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.helpUrl);
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* string placeholder = 4; */
        if (message.placeholder !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.placeholder);
        /* bool post_create = 5; */
        if (message.postCreate !== false)
            writer.tag(5, WireType.Varint).bool(message.postCreate);
        /* repeated string depends_on_fields = 6; */
        for (let i = 0; i < message.dependsOnFields.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.dependsOnFields[i]);
        /* string additional_placeholder = 7; */
        if (message.additionalPlaceholder !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.additionalPlaceholder);
        /* c1.api.integration.connector.v1.StringField str = 100; */
        if (message.field.oneofKind === "str")
            StringField.internalBinaryWrite(message.field.str, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.integration.connector.v1.SelectField select = 101; */
        if (message.field.oneofKind === "select")
            SelectField.internalBinaryWrite(message.field.select, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.integration.connector.v1.RandomStringField random = 102; */
        if (message.field.oneofKind === "random")
            RandomStringField.internalBinaryWrite(message.field.random, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.integration.connector.v1.ImportField import = 103; */
        if (message.field.oneofKind === "import")
            ImportField.internalBinaryWrite(message.field.import, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.integration.connector.v1.OAuth2Field oauth2 = 104; */
        if (message.field.oneofKind === "oauth2")
            OAuth2Field.internalBinaryWrite(message.field.oauth2, writer.tag(104, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.integration.connector.v1.ReadOnlyField read_only = 105; */
        if (message.field.oneofKind === "readOnly")
            ReadOnlyField.internalBinaryWrite(message.field.readOnly, writer.tag(105, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.integration.connector.v1.OptionsField options = 106; */
        if (message.field.oneofKind === "options")
            OptionsField.internalBinaryWrite(message.field.options, writer.tag(106, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.integration.connector.v1.CheckboxField checkbox = 107; */
        if (message.field.oneofKind === "checkbox")
            CheckboxField.internalBinaryWrite(message.field.checkbox, writer.tag(107, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.integration.connector.v1.RotatableSecretField secret = 108; */
        if (message.field.oneofKind === "secret")
            RotatableSecretField.internalBinaryWrite(message.field.secret, writer.tag(108, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.integration.connector.v1.StringListField str_list = 109; */
        if (message.field.oneofKind === "strList")
            StringListField.internalBinaryWrite(message.field.strList, writer.tag(109, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.integration.connector.v1.TextField text = 110; */
        if (message.field.oneofKind === "text")
            TextField.internalBinaryWrite(message.field.text, writer.tag(110, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.integration.connector.v1.KeyValueField key_value = 111; */
        if (message.field.oneofKind === "keyValue")
            KeyValueField.internalBinaryWrite(message.field.keyValue, writer.tag(111, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.integration.connector.v1.StringMapField string_map = 112; */
        if (message.field.oneofKind === "stringMap")
            StringMapField.internalBinaryWrite(message.field.stringMap, writer.tag(112, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.Field
 */
export const Field = new Field$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StringField$Type extends MessageType<StringField> {
    constructor() {
        super("c1.api.integration.connector.v1.StringField", [
            { no: 1, name: "secret", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "value_validator", kind: "message", T: () => StringRules }
        ]);
    }
    create(value?: PartialMessage<StringField>): StringField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.secret = false;
        if (value !== undefined)
            reflectionMergePartial<StringField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StringField): StringField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool secret */ 1:
                    message.secret = reader.bool();
                    break;
                case /* validate.StringRules value_validator */ 2:
                    message.valueValidator = StringRules.internalBinaryRead(reader, reader.uint32(), options, message.valueValidator);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StringField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool secret = 1; */
        if (message.secret !== false)
            writer.tag(1, WireType.Varint).bool(message.secret);
        /* validate.StringRules value_validator = 2; */
        if (message.valueValidator)
            StringRules.internalBinaryWrite(message.valueValidator, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.StringField
 */
export const StringField = new StringField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StringListField$Type extends MessageType<StringListField> {
    constructor() {
        super("c1.api.integration.connector.v1.StringListField", [
            { no: 1, name: "value_validator", kind: "message", T: () => StringRules }
        ]);
    }
    create(value?: PartialMessage<StringListField>): StringListField {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<StringListField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StringListField): StringListField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* validate.StringRules value_validator */ 1:
                    message.valueValidator = StringRules.internalBinaryRead(reader, reader.uint32(), options, message.valueValidator);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StringListField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* validate.StringRules value_validator = 1; */
        if (message.valueValidator)
            StringRules.internalBinaryWrite(message.valueValidator, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.StringListField
 */
export const StringListField = new StringListField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class KeyValueField$Type extends MessageType<KeyValueField> {
    constructor() {
        super("c1.api.integration.connector.v1.KeyValueField", [
            { no: 1, name: "secret", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<KeyValueField>): KeyValueField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.secret = false;
        if (value !== undefined)
            reflectionMergePartial<KeyValueField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: KeyValueField): KeyValueField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool secret */ 1:
                    message.secret = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: KeyValueField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool secret = 1; */
        if (message.secret !== false)
            writer.tag(1, WireType.Varint).bool(message.secret);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.KeyValueField
 */
export const KeyValueField = new KeyValueField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StringMapField$Type extends MessageType<StringMapField> {
    constructor() {
        super("c1.api.integration.connector.v1.StringMapField", [
            { no: 1, name: "optional", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<StringMapField>): StringMapField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.optional = false;
        if (value !== undefined)
            reflectionMergePartial<StringMapField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StringMapField): StringMapField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool optional */ 1:
                    message.optional = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: StringMapField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool optional = 1; */
        if (message.optional !== false)
            writer.tag(1, WireType.Varint).bool(message.optional);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.StringMapField
 */
export const StringMapField = new StringMapField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReadOnlyField$Type extends MessageType<ReadOnlyField> {
    constructor() {
        super("c1.api.integration.connector.v1.ReadOnlyField", []);
    }
    create(value?: PartialMessage<ReadOnlyField>): ReadOnlyField {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ReadOnlyField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReadOnlyField): ReadOnlyField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReadOnlyField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ReadOnlyField
 */
export const ReadOnlyField = new ReadOnlyField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SelectField$Type extends MessageType<SelectField> {
    constructor() {
        super("c1.api.integration.connector.v1.SelectField", [
            { no: 5, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SelectField_Item }
        ]);
    }
    create(value?: PartialMessage<SelectField>): SelectField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<SelectField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SelectField): SelectField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.integration.connector.v1.SelectField.Item items */ 5:
                    message.items.push(SelectField_Item.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SelectField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.integration.connector.v1.SelectField.Item items = 5; */
        for (let i = 0; i < message.items.length; i++)
            SelectField_Item.internalBinaryWrite(message.items[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.SelectField
 */
export const SelectField = new SelectField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SelectField_Item$Type extends MessageType<SelectField_Item> {
    constructor() {
        super("c1.api.integration.connector.v1.SelectField.Item", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SelectField_Item>): SelectField_Item {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial<SelectField_Item>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SelectField_Item): SelectField_Item {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* string value */ 2:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SelectField_Item, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* string value = 2; */
        if (message.value !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.SelectField.Item
 */
export const SelectField_Item = new SelectField_Item$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RandomStringField$Type extends MessageType<RandomStringField> {
    constructor() {
        super("c1.api.integration.connector.v1.RandomStringField", [
            { no: 1, name: "length", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<RandomStringField>): RandomStringField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.length = 0;
        if (value !== undefined)
            reflectionMergePartial<RandomStringField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RandomStringField): RandomStringField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 length */ 1:
                    message.length = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RandomStringField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 length = 1; */
        if (message.length !== 0)
            writer.tag(1, WireType.Varint).int32(message.length);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.RandomStringField
 */
export const RandomStringField = new RandomStringField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImportField$Type extends MessageType<ImportField> {
    constructor() {
        super("c1.api.integration.connector.v1.ImportField", [
            { no: 1, name: "secret", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "value_validator", kind: "message", T: () => StringRules },
            { no: 3, name: "allowed_extensions", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ImportField>): ImportField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.secret = false;
        message.allowedExtensions = [];
        if (value !== undefined)
            reflectionMergePartial<ImportField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ImportField): ImportField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool secret */ 1:
                    message.secret = reader.bool();
                    break;
                case /* validate.StringRules value_validator */ 2:
                    message.valueValidator = StringRules.internalBinaryRead(reader, reader.uint32(), options, message.valueValidator);
                    break;
                case /* repeated string allowed_extensions */ 3:
                    message.allowedExtensions.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ImportField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool secret = 1; */
        if (message.secret !== false)
            writer.tag(1, WireType.Varint).bool(message.secret);
        /* validate.StringRules value_validator = 2; */
        if (message.valueValidator)
            StringRules.internalBinaryWrite(message.valueValidator, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated string allowed_extensions = 3; */
        for (let i = 0; i < message.allowedExtensions.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.allowedExtensions[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ImportField
 */
export const ImportField = new ImportField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OAuth2Field$Type extends MessageType<OAuth2Field> {
    constructor() {
        super("c1.api.integration.connector.v1.OAuth2Field", []);
    }
    create(value?: PartialMessage<OAuth2Field>): OAuth2Field {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<OAuth2Field>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OAuth2Field): OAuth2Field {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OAuth2Field, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.OAuth2Field
 */
export const OAuth2Field = new OAuth2Field$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OptionsField$Type extends MessageType<OptionsField> {
    constructor() {
        super("c1.api.integration.connector.v1.OptionsField", []);
    }
    create(value?: PartialMessage<OptionsField>): OptionsField {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<OptionsField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: OptionsField): OptionsField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: OptionsField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.OptionsField
 */
export const OptionsField = new OptionsField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckboxField$Type extends MessageType<CheckboxField> {
    constructor() {
        super("c1.api.integration.connector.v1.CheckboxField", [
            { no: 1, name: "checked", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CheckboxField>): CheckboxField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.checked = false;
        if (value !== undefined)
            reflectionMergePartial<CheckboxField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckboxField): CheckboxField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool checked */ 1:
                    message.checked = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckboxField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool checked = 1; */
        if (message.checked !== false)
            writer.tag(1, WireType.Varint).bool(message.checked);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.CheckboxField
 */
export const CheckboxField = new CheckboxField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RotatableSecretField$Type extends MessageType<RotatableSecretField> {
    constructor() {
        super("c1.api.integration.connector.v1.RotatableSecretField", []);
    }
    create(value?: PartialMessage<RotatableSecretField>): RotatableSecretField {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RotatableSecretField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RotatableSecretField): RotatableSecretField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RotatableSecretField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.RotatableSecretField
 */
export const RotatableSecretField = new RotatableSecretField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TextField$Type extends MessageType<TextField> {
    constructor() {
        super("c1.api.integration.connector.v1.TextField", [
            { no: 1, name: "value_validator", kind: "message", T: () => StringRules },
            { no: 2, name: "secret", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<TextField>): TextField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.secret = false;
        if (value !== undefined)
            reflectionMergePartial<TextField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TextField): TextField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* validate.StringRules value_validator */ 1:
                    message.valueValidator = StringRules.internalBinaryRead(reader, reader.uint32(), options, message.valueValidator);
                    break;
                case /* bool secret */ 2:
                    message.secret = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TextField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* validate.StringRules value_validator = 1; */
        if (message.valueValidator)
            StringRules.internalBinaryWrite(message.valueValidator, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool secret = 2; */
        if (message.secret !== false)
            writer.tag(2, WireType.Varint).bool(message.secret);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.TextField
 */
export const TextField = new TextField$Type();
/**
 * @generated ServiceType for protobuf service c1.api.integration.connector.v1.ConnectorCatalogService
 */
export const ConnectorCatalogService = new ServiceType("c1.api.integration.connector.v1.ConnectorCatalogService", [
    { name: "ListInstallations", options: { "authz.method": { role: "VIEWER" } }, I: ConnectorCatalogServiceListInstallationsRequest, O: ConnectorCatalogServiceListInstallationsResponse },
    { name: "SearchInstallations", options: { "authz.method": { role: "VIEWER" } }, I: ConnectorCatalogServiceSearchInstallationsRequest, O: ConnectorCatalogServiceSearchInstallationsResponse },
    { name: "GetInstallation", options: { "authz.method": { role: "VIEWER" } }, I: ConnectorCatalogServiceGetInstallationRequest, O: ConnectorCatalogServiceGetInstallationResponse },
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: ConnectorCatalogServiceSearchRequest, O: ConnectorCatalogServiceSearchResponse },
    { name: "ConfigurationSchema", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/connectorcatalog", group: "Connector Catalog" }] }, "authz.method": { role: "VIEWER" } }, I: ConnectorCatalogServiceConfigurationSchemaRequest, O: ConnectorCatalogServiceConfigurationSchemaResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: ConnectorCatalogServiceGetRequest, O: ConnectorCatalogServiceGetResponse },
    { name: "SearchAppsForInstallation", options: { "authz.method": { role: "VIEWER" } }, I: ConnectorCatalogServiceSearchAppsForInstallationRequest, O: ConnectorCatalogServiceSearchAppsForInstallationResponse }
]);
